import { escrowOfficerCard, insertIntoArray } from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const WAOverrides: OfferLocaleOverrides = {
  locale: 'WA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: '',
            },
          },
        },
        salesPriceCard: {
          layout: (layout) =>
            insertIntoArray(layout, 1, [
              {
                name: 'salesAgreementNumber',
                size: 100,
              },
            ]),
          fields: {
            salesAgreementNumber: {
              name: 'salesAgreementNumber',
              entity: 'interaction',
              type: 'text',
              label: 'Sales Agreement Number',
              placeholderText: '',
            },
          },
        },
      },
    },
    buySideContacts: {
      cards: {
        buyersAgentCard: {
          action: {
            props: (props) =>
              props.concat([
                {
                  from: 'primaryMls',
                  to: 'contacts.agent.x.primaryMls',
                },
                {
                  from: 'brokerageOfficeEmail',
                  to: 'contacts.agent.x.brokerage.officeEmail',
                },
              ]),
          },
          layout: (layout) => [
            ...insertIntoArray(layout, 5, [
              {
                name: 'contacts.agent.x.brokerage.officeEmail',
                size: 100,
              },
            ]),
            [
              {
                name: 'contacts.agent.x.primaryMls',
                size: 33,
              },
              {
                name: 'contacts.agent.x.mlsId',
                size: 33,
              },
              {
                name: 'contacts.agent.x.brokerage.mlsId',
                size: 34,
              },
            ],
          ],
          fields: {
            firstName: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'primaryMls',
                      to: 'contacts.agent.x.primaryMls',
                    },
                    {
                      from: 'brokerage.officeEmail',
                      to: 'contacts.agent.x.brokerage.officeEmail',
                    },
                    {
                      from: 'brokerage.mlsId',
                      to: 'contacts.agent.x.brokerage.mlsId',
                    },
                  ]),
              },
            },
            submitAs: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'primaryMls',
                      to: 'contacts.agent.x.primaryMls',
                    },
                  ]),
              },
            },
            brokerageOfficeEmail: {
              name: 'contacts.agent.x.brokerage.officeEmail',
              entity: 'contacts',
              entityType: 'agent',
              type: 'text',
              label: 'Brokerage Office Email',
              placeholderText: '',
              disabledForIndex: 0,
              validation: [
                {
                  type: 'email',
                  message: 'Invalid Email',
                },
              ],
            },
            brokerageMlsId: {
              type: 'text',
              label: 'Brokerage MLS ID Number',
              placeholderText: '',
              disabledForIndex: -1,
            },
            primaryMls: {
              name: 'contacts.agent.x.primaryMls',
              entity: 'contacts',
              entityType: 'agent',
              type: 'text',
              label: 'Primary MLS',
              placeholderText: '',
              disabledForIndex: -1,
            },
            mlsId: {
              name: 'contacts.agent.x.mlsId',
              entity: 'contacts',
              entityType: 'agent',
              type: 'text',
              label: 'Agent MLS ID Number',
              placeholderText: '',
              disabledForIndex: -1,
            },
          },
        },
        buyerCard: {
          layout: (layout) =>
            insertIntoArray(layout, 5, [
              {
                name: 'contacts.client.x.ownershipStatus',
                size: 100,
              },
            ]),
          fields: {
            ownershipStatus: {
              name: 'contacts.client.x.ownershipStatus',
              entity: 'contacts',
              entityType: 'client',
              type: 'select',
              label: 'Ownership Status',
              options: [
                {
                  label: '',
                  value: 'A Limited Liability partnership',
                },
                {
                  label: '',
                  value: 'A limited liability company',
                },
                {
                  label: '',
                  value: 'A general partnership',
                },
                {
                  label: '',
                  value: 'A limited partnership',
                },
                {
                  label: '',
                  value: 'A corporation',
                },
                {
                  label: '',
                  value: 'Unmarried person',
                },
                {
                  label: '',
                  value: 'An unmarried person',
                },
                {
                  label: '',
                  value: 'Married as separate property',
                },
                {
                  label: '',
                  value: 'A married couple',
                },
                {
                  label: '',
                  value: 'Domestic partners',
                },
              ],
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAgentCard: {
          layout: (layout) => [
            ...insertIntoArray(layout, 5, [
              {
                name: 'contacts.counterpartyAgent.x.brokerage.officeEmail',
                size: 100,
              },
            ]),
            [
              {
                name: 'contacts.counterpartyAgent.x.primaryMls',
                size: 33,
              },
              {
                name: 'contacts.counterpartyAgent.x.mlsId',
                size: 33,
              },
              {
                name: 'contacts.counterpartyAgent.x.brokerage.mlsId',
                size: 34,
              },
            ],
          ],
          fields: {
            firstName: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'primaryMls',
                      to: 'contacts.counterpartyAgent.x.primaryMls',
                    },
                    {
                      from: 'brokerage.officeEmail',
                      to: 'contacts.counterpartyAgent.x.brokerage.officeEmail',
                    },
                    {
                      from: 'brokerage.mlsId',
                      to: 'contacts.counterpartyAgent.x.brokerage.mlsId',
                    },
                  ]),
              },
            },
            brokerageOfficeEmail: {
              name: 'contacts.counterpartyAgent.x.brokerage.officeEmail',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Brokerage Office Email',
              placeholderText: '',
              disabledForIndex: -1,
              validation: [
                {
                  type: 'email',
                  message: 'Invalid Email',
                },
              ],
            },
            primaryMls: {
              name: 'contacts.counterpartyAgent.x.primaryMls',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Primary MLS',
              placeholderText: '',
              disabledForIndex: -1,
            },
            mlsId: {
              name: 'contacts.counterpartyAgent.x.mlsId',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Agent MLS ID Number',
              placeholderText: '',
              disabledForIndex: -1,
            },
            brokerageMlsId: {
              name: 'contacts.counterpartyAgent.x.brokerage.mlsId',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Brokerage MLS ID Number',
              placeholderText: '',
              disabledForIndex: -1,
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        escrow: {
          ...escrowOfficerCard,
          order: -1,
        },
      },
    },
  },
};
